import { appApi } from '../api/appApi';
import { createTokenProvider, type TokenProvider } from '../lib/tokenProvider';

let provider: TokenProvider | null = null;

/** The one data-token provider for the session (tiles, manifest and events all share it). */
export function dataTokenProvider(): TokenProvider {
  provider ??= createTokenProvider({ fetchToken: () => appApi.getDataToken() });
  return provider;
}

export const getDataToken = (): Promise<string> => dataTokenProvider().getToken();

export function resetDataToken(): void {
  provider?.dispose();
  provider = null;
}
